export const ImageUtils = {

    getFullUrlImage: relativePath => {
      if (relativePath) {
        if (relativePath.startsWith('http') || relativePath.startsWith('https')) {
          return relativePath
        }
        return process.env.VUE_APP_BASE_FILES_URL + relativePath
      }
    }
  
  }
  
  export default ImageUtils
  